import { CreateEventDto, ToggleEventDto } from '@sr/dto';
import { eventsApi } from '../api';

export const useUpdateEventToggle = () => {
  const [update] = eventsApi.useUpdateEventToggleMutation();
  return async (data: {id: number} & ToggleEventDto) => {
    return update(data).unwrap();
  };
};

export const useUpdateEventsCompleted = () => {
  const [updateEventsCompleted] = eventsApi.useUpdateEventsCompletedMutation();
  return async (ids: number[]) => {
    return updateEventsCompleted(ids).unwrap();
  };
};

export const useAddEvent = (companyId: number) => {
  const [addEvent] = eventsApi.useAddEventMutation();
  return async (newEvent : CreateEventDto)=>{
    return addEvent({ companyId, dto: newEvent }).unwrap();
  };
};

export const useAddCase = () => {
  const [addCase] = eventsApi.useAddCaseMutation();
  return async (newEvent : CreateEventDto)=>{
    return addCase({ dto: newEvent }).unwrap();
  };
};